import { faMagic } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';

const ConfirmationMessage = ({
  title,
  subtitle,
  icon,
  className,
  titleClassName,
  subtitleClassName,
  iconClassName,
  role,
  labelledById,
}) => {
  return (
    <div
      className={`confirm-message ${className || ''}`.trim()}
      role={role}
      aria-labelledby={labelledById}
    >
      <div className={`confirm-message__icon ${iconClassName || ''}`.trim()} aria-hidden='true'>
        <FontAwesomeIcon icon={icon || faMagic} />
      </div>
      <div className='confirm-message__content'>
        <div id={labelledById} className={`confirm-message__title ${titleClassName || ''}`.trim()}>
          {title}
        </div>
        {subtitle ? (
          <div className={`confirm-message__subtitle ${subtitleClassName || ''}`.trim()}>
            {subtitle}
          </div>
        ) : null}
      </div>
    </div>
  );
};

ConfirmationMessage.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  icon: PropTypes.any,
  className: PropTypes.string,
  titleClassName: PropTypes.string,
  subtitleClassName: PropTypes.string,
  iconClassName: PropTypes.string,
  role: PropTypes.string,
  labelledById: PropTypes.string,
};

ConfirmationMessage.defaultProps = {
  subtitle: '',
  icon: undefined,
  className: '',
  titleClassName: '',
  subtitleClassName: '',
  iconClassName: '',
  role: 'region',
  labelledById: 'confirm-message-title',
};

export default ConfirmationMessage;
